import { Component, computed, input, output, signal, viewChildren } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidAssessmentToast } from '../../components/rid-assessment-toast/rid-assessment-toast';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidSentence } from '../../components/rid-sentence/rid-sentence';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';

@Component({
  selector: 'rid-focus-reading',
  imports: [
    RidMechanicWrapper,
    RidMechanicBackground,
    RidTopBar,
    RidMechanicContent,
    RidAssessmentToast,
    RidMechanicTitle,
    RidSentence,
    RidBottomButton,
  ],
  templateUrl: './rid-focus-reading.html',
  host: {
    class: 'block',
  },
})
export class RidFocusReading {
  sentencess = input.required<string[][]>();
  pace = input.required<number>();

  sentenceComps = viewChildren<RidSentence>('sentences');
  step = signal(0);
  sentences = computed(() => this.sentencess()[this.step()]);
  state = signal<{ type: 'STARTING' } | { type: 'READING'; index: number } | { type: 'ASSESSING'; index: number } | { type: 'REVIEWING' }>({
    type: 'STARTING',
  });

  finished = output<void>();

  start() {
    this.pass(0, this.pace());
  }

  async pass(index: number, pace: number) {
    this.state.set({ type: 'READING', index });
    await this.sentenceComps()[index].pass(pace, { opacity: 1, scale: 1 }, { opacity: 0, scale: 1 });

    this.assess(index);
  }

  assess(index: number) {
    this.state.set({ type: 'ASSESSING', index });
  }

  assessed(result: 'CORRECT' | 'INCORRECT') {
    this.nextSentence();
  }

  async nextSentence() {
    const state = this.state();
    if (!('index' in state)) throw new Error('Invalid state');

    const nextIndex = state.index + 1;

    if (nextIndex >= this.sentences().length) {
      this.review();
    } else {
      this.sentenceComps()
        .at(nextIndex - 1)
        ?.hide();

      await this.pass(nextIndex, this.pace());
    }
  }

  review() {
    this.state.set({ type: 'REVIEWING' });
    this.sentenceComps().forEach((comp) => comp.show());
  }

  async nextStory() {
    this.step.update((s) => s + 1);
    this.state.set({ type: 'STARTING' });

    await delay(1000);
    this.start();
  }

  finish() {
    this.finished.emit();
  }
}
